export default __webpack_public_path__ + "static/media/scan-bunifikasi-logotype-l.768db527.svg";